// extracted by mini-css-extract-plugin
module.exports = {"controlContainer":"no-results_controlContainer__y8Btz","header":"no-results_header__aTtsg","sectionContainer":"no-results_sectionContainer__7fOiW"};